import { Eye } from "lucide-react"
import { Button } from "../ui/button"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table"
import { useEffect, useState } from "react";
import admin from "@/shared/api/admin";
import { useNavigate } from "react-router-dom";


export const UsersList = () => {
    const [users, setUsers] = useState([]);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [loading, setLoading] = useState(false);
    const [verified, setVerified] = useState(undefined);

    const navigate = useNavigate();

    const fetchUsers = async () => {
        setLoading(true);
        try {
            const res = await admin.getUsers(page, limit, verified);
            setUsers(res.users);
        } catch (err) {
            console.error(err.message);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchUsers().catch(console.error);
    }, [page, limit, verified]);

    const handleUserClick = (id) => {
        navigate(`/admin/users/${id}`)
    }

    const formatDate = (date) => {
        const options = { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' };
        return new Date(date).toLocaleDateString('ru-RU', options);
    }

    const toggleVerified = (id) => {
        setVerified(prev => {
            if (prev === undefined) {
                return true;
            } else if (prev === true) {
                return false;
            } else {
                return undefined;
            }
        });
    }

    const verifiedText = verified === undefined ? "Все" : verified ? "Верифицированные" : "Не верифицированные";

    return (
        <div className="bg-card rounded-lg border p-6">
            <div className="flex justify-between items-center mb-4">
                <h2 className="my-4">Пользователи</h2>
                <Button
                    variant="outline"
                    size="sm"
                    onClick={toggleVerified}
                    disabled={loading}
                >
                    <Eye className="h-4 w-4 mr-1" />
                    {verifiedText}
                </Button>
            </div>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead>Верифицирован</TableHead>
                        <TableHead>Зарегестрирован</TableHead>
                        <TableHead>ID</TableHead>
                        <TableHead>Name</TableHead>
                        <TableHead>Email</TableHead>
                        <TableHead className="w-[100px]">Действия</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {users.map((user) => (
                        <TableRow key={user._id}>
                            <TableCell>{user.verified ? "✅" : "❌"}</TableCell>
                            <TableCell>{formatDate(user.createdAt)}</TableCell>
                            <TableCell>{user._id}</TableCell>
                            <TableCell>{user.name ?? "—"}</TableCell>
                            <TableCell>{user.email}</TableCell>
                            <TableCell>
                                <Button
                                    variant="outline"
                                    size="sm"
                                    onClick={() => handleUserClick(user._id)}
                                >
                                    <Eye className="h-4 w-4 mr-1" />
                                    Посмотреть
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <div className="flex justify-center mt-4">
                <Button
                    variant="outline"
                    size="sm"
                    onClick={() => setPage(page + 1)}
                    disabled={loading || page * limit >= users.length}
                >
                    {loading ? "Loading..." : "Загрузить еще"}
                </Button>
            </div>
        </div>
    )
}